import { getSessionStorage } from "@jti/rest-api";
import { useSelector } from "@jti/store/reduxHooks";
import { CheckoutV2LoyaltyChoice } from "@jti/store/slices/checkoutV2Slice";

import { getLoyaltyUserSelection, LOYALTY_CART_POINTS_STORAGE_KEY } from "@checkout-v2/features/LoyaltyPoints/utils";

import type { LoyaltyPreviewState } from "../../components/PaymentMethodsSectionPreview/PaymentMethodsSectionPreview.types";

export const useLoyaltyPreview = (cartId?: string): LoyaltyPreviewState => {
  const loyaltyChoice = useSelector((state) => state.checkoutV2.loyaltyPointsState.loyaltyChoice);
  const loyaltyPoints = useSelector((state) => state.checkoutV2.loyaltyPointsState.loyaltyPoints) ?? 0;
  const loyaltyVoucherPrice = useSelector((state) => state.checkoutV2.loyaltyPointsState.loyaltyVoucher?.price ?? 0);
  const loyaltyVoucherPoints = useSelector((state) => state.checkoutV2.loyaltyPointsState.loyaltyVoucher?.points ?? 0);
  const sessionStorage = getSessionStorage();

  const storedUserSelection = getLoyaltyUserSelection();
  const storedCartPoints = sessionStorage.get(LOYALTY_CART_POINTS_STORAGE_KEY, 0);
  const isStoredCollectSelectionMatchingCurrentCart =
    !!cartId &&
    storedUserSelection.cartId === cartId &&
    storedUserSelection.loyaltyChoice === CheckoutV2LoyaltyChoice.COLLECT;

  if (loyaltyChoice === CheckoutV2LoyaltyChoice.COLLECT && loyaltyPoints > 0) {
    return {
      isLoyaltyInfoVisible: true,
      loyaltyInfo: {
        choice: CheckoutV2LoyaltyChoice.COLLECT,
        points: loyaltyPoints,
      },
    };
  }

  if (
    storedCartPoints > 0 &&
    isStoredCollectSelectionMatchingCurrentCart &&
    (loyaltyChoice === undefined || loyaltyChoice === CheckoutV2LoyaltyChoice.COLLECT)
  ) {
    return {
      isLoyaltyInfoVisible: true,
      loyaltyInfo: {
        choice: CheckoutV2LoyaltyChoice.COLLECT,
        points: storedCartPoints,
      },
    };
  }

  if (loyaltyChoice === CheckoutV2LoyaltyChoice.REDEEM && loyaltyVoucherPoints > 0) {
    return {
      isLoyaltyInfoVisible: true,
      loyaltyInfo: {
        choice: CheckoutV2LoyaltyChoice.REDEEM,
        points: loyaltyVoucherPoints,
        voucherPrice: loyaltyVoucherPrice,
      },
    };
  }

  return { isLoyaltyInfoVisible: false };
};
